module.exports = __webpack_public_path__ + "img/xieuxiaoguanl.28ca8cc0.png";